import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const personio = defineConnector({
  identifier: "personio",
  name: "Personio",
  tagLine: "HR management platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.personio\\.de/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://api.personio.de/v1/auth",
        jsonBody: {
          client_id: app.secret.clientId,
          client_secret: app.secret.clientSecret,
        },
      },
      extract: { from: "jsonPath", paths: ["data.token", "access_token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Create API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In Personio, go to **Settings → Integrations → API credentials** and generate a new set of credentials. Copy the client ID and client secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "secrets", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "secrets", field: "clientSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.personio.de/v1/company/employees?limit=1",
  },
});
